import { render, staticRenderFns } from "./MenuPopupBar.vue?vue&type=template&id=f4bff10e&scoped=true&"
import script from "./MenuPopupBar.vue?vue&type=script&lang=ts&"
export * from "./MenuPopupBar.vue?vue&type=script&lang=ts&"
import style0 from "./MenuPopupBar.vue?vue&type=style&index=0&id=f4bff10e&scoped=true&lang=scss&"
import style1 from "./MenuPopupBar.vue?vue&type=style&index=1&id=f4bff10e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bff10e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VIcon,VSpacer,VToolbarTitle})
